<template>
  <div>
    <v-chip small class="ma-2" color="primary">
      <span>{{ definitions.length }} words</span>
    </v-chip>
    <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    <v-data-table :headers="headers" :items="definitions" :items-per-page="15" :search="search" sort-by="word" :sort-desc="false" class="elevation-1">
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
        <dictionary-dialog :dialog="dialog" :definition="definition" :isUpdating="isUpdating" :isRemoving="isRemoving" @cancel="cancel()">
    </dictionary-dialog>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import dictionaryDialog from '@/dialogs/diaDictionary'

  export default {
    computed: {
      ...mapState('definitions', ['definitions']),
      searchFiltered() {
        if (this.search) {
          return this.definitions.filter((item) => item.word.toLowerCase().includes(this.search.toLowerCase())
            || item.definition.toLowerCase().includes(this.search.toLowerCase()))
        } else {
          return this.definitions
        }
      }
    },
    data() {
      return {
        dialog: false,
        isUpdating: false,
        isRemoving: false,
        expand: false,
        definition: {},
        search: "",
        headers: [{
            text: 'Word',
            value: 'word'
          },
          {
            text: 'Meaning',
            value: 'definition'
          },
          {
            text: 'Created',
            value: 'created_at'
          },
          {
            text: 'Updated',
            value: 'updated_at'
          }
        ]
      }
    },
    components: {
      dictionaryDialog
    },
    methods: {
      showDialog(item, isUpdating){
        if(isUpdating){
          this.isUpdating = true
        } else {
          this.isRemoving = true
        }
        this.dialog = true
        this.definition = item
      },
      cancel() {
        this.dialog = false
        this.isUpdating = false
        this.isRemoving = false
        this.definition = {}
      }
    },
    created() {
      this.$store.dispatch('definitions/fetch')
    }
  }
</script>